module.exports = __webpack_public_path__ + "img/8.fdc1a5dc.png";